import React from "react";

import LocaleWrap from "./wrapPageElement";

export const wrapPageElement = LocaleWrap;
